import { PageMeta } from "components/PageMeta"
import { V3StaticLayout } from "layouts/v3Static"
import { Discover } from "modules/discover/views/Discover"
import { type GetServerSidePropsContext } from "next"
import { Suspense } from "react"

const title = "Discover"
export const DEFAULT_TAG = "all"

type DiscoverPageProps = {
  tag: string
  initialSearch?: string
}

const DiscoverPage = ({ tag, initialSearch }: DiscoverPageProps) => {
  return (
    <>
      <PageMeta meta={{ title }} noIndex />
      <Suspense fallback={null}>
        <Discover tag={tag} initialSearch={initialSearch} />
      </Suspense>
    </>
  )
}

DiscoverPage.getLayout = V3StaticLayout

export default DiscoverPage

export async function getServerSideProps(context: GetServerSidePropsContext) {
  return {
    props: {
      tag: context.query?.category || DEFAULT_TAG,
      initialSearch: context.query?.search || "",
    },
  }
}
